import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWikiLogoMobile = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 29,
	height: 29,
	viewBox: "0 0 29 29",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7266 12.9533V21.3826C10.2466 20.9959 7.53993 18.0572 7.53993 14.4999C7.53993 12.4119 8.46791 10.4786 10.0146 9.24124L13.7266 12.9533Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.4599 14.4999C21.4599 18.0572 18.7532 21.0732 15.2732 21.3826V12.9533L18.9852 9.24124C20.5319 10.4786 21.4599 12.4119 21.4599 14.4999Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.3106 5.91593L20.1452 8.0812C21.9239 9.62789 23.0066 11.9479 23.0066 14.4999C23.0066 19.2172 19.2172 23.0065 14.4999 23.0065C9.78256 23.0065 5.99323 19.2172 5.99323 14.4999C5.99323 11.9479 7.15325 9.70524 8.85458 8.0812L6.68923 5.91593C4.36925 8.0812 2.8999 11.0972 2.8999 14.4999C2.8999 20.9185 8.08123 26.0998 14.4999 26.0998C20.9186 26.0998 26.0999 20.9185 26.0999 14.4999C26.0999 11.0972 24.6306 8.0812 22.3106 5.91593Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4999 10.6332C16.6354 10.6332 18.3665 8.90204 18.3665 6.76656C18.3665 4.63108 16.6354 2.8999 14.4999 2.8999C12.3644 2.8999 10.6332 4.63108 10.6332 6.76656C10.6332 8.90204 12.3644 10.6332 14.4999 10.6332Z",
			fill: "white"
		})
	]
});
export default SvgWikiLogoMobile;
